import React from 'react'

interface SVGCloseBurguerProps {
  width?: string;
  height?: string;
  color?: string;
  strokeWidth?: string;
}

const SVGCloseBurguer = ({ width = '32', height = '32', color = '#000', strokeWidth = '2' }: SVGCloseBurguerProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 23L23.1421 8.85789" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      <path d="M9 8.99998L23.1421 23.1421" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
    </svg>
  )
}

export default SVGCloseBurguer
